import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-batchstamp',
  template: `<router-outlet></router-outlet>`,
  encapsulation: ViewEncapsulation.None
})
export class BatchstampComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/batchstamp.component.ts